import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";

i18n.use(initReactI18next)
    .use(detector)
    .init({
        resources: {
            en: {
                translations: {
                    access: "Access",
                    add: "Add",
                    addAccess: "Add access",
                    addOption: "Add option",
                    addPresenter: "Add presenter",
                    addQuestion: "Add question",
                    addResponseNumber: "Add a maximum number of response per attendee :",
                    addResponseTime: "Add a response time :",
                    attendee: "Attendees",
                    backHome: "Back home",
                    broadcast: "Broadcast",
                    cancel: "Cancel",
                    confirmDelete: "Are you sure to delete ?",
                    content: "Content",
                    createFirstSlide: "Create your first slide",
                    delete: "Delete",
                    deleteSlideshow: "Delete the slideshow",
                    enterCode: "Enter code to join : ",
                    enterResponse: "Enter your response",
                    errorMessage: {
                        emptyCode: "Code is necessary",
                        emptyTitle: "Title is necessary",
                        invalidCode: "Invalid code",
                    },
                    hideRanking: "Hide ranking",
                    languages: {
                        english: "English",
                        french: "French",
                        other: "Others"
                    },
                    livePolling: "Live Polling",
                    myPresentations: "My presentations",
                    newSlide: "Slide",
                    newSlideshow: "Slideshow",
                    next: "Next",
                    no: "No",
                    numberParticipations: "Nomber of participations : ",
                    possibleResponseNumber: "Maximum number of response per participant",
                    previous: "Previous",
                    presentation: {
                        join: "Join the presentation",
                        manage: "Manage presentation",
                        present: "Present",
                        isPresenter: "Are you presenter ?"
                    },
                    presentationAccess: "You don't have access to any presentation",
                    presentationFinished: "The presentation is finished",
                    question: "Question",
                    quiz: "Quiz",
                    required: {
                        options: "Minimum two options are required",
                        question: "Question required",
                        response: "Response is required",
                        responseNumber: "Maximum response number per participant is required",
                        responseTime: "Maximum response time is required",
                        type :"Type required"
                    },
                    response: "Response",
                    responseOption:"Response option",
                    responseTime: "Response time (sec)",
                    responseRequired: "A response is required",
                    responseSent: "Your response has been sent",
                    roles: {
                        author: "Author",
                        owner: "Owner",
                        presenter: "Presenter",
                        reader: "Reader",
                    },
                    save: "Save",
                    selectPresentation: "Select a presentation",
                    selectResponse: 'Select the correct response :',
                    send: "Send",
                    shareCode: "Share this code to your attendees : ",
                    showRanking: "Show ranking",
                    showResponses: "Show responses",
                    showTestResponses: "Show test responses :",
                    slideshowAccess: "No slideshow available",
                    slideshowLabel: "Title",
                    slideType: {
                        livePolling: "Live Polling",
                        presentation: "Presentation",
                        quiz: "Quiz",
                        wordCloud: "Word Cloud",
                    },
                    startPresentation: "Start presentation",
                    timeIsUp: "Time is up !",
                    timeRemaining: "Time remaining : ",
                    title: "Title",
                    type:"Type",
                    waitPresenter: "Waiting for presentation to start",
                    wordCloud: "Word Cloud",
                    yes: "Yes",
                    yourResponse: "Your response :"
                }
            },
            fr: {
                translations: {
                    access: "Accès",
                    add: "Ajouter",
                    addAccess: "Ajouter un accès",
                    addOption: "Ajouter option",
                    addPresenter: "Ajouter un présentateur",
                    addQuestion: "Ajouter question",
                    addResponseNumber: "Ajouter un nombre de réponse maximale par participant :",
                    addResponseTime: "Ajouter un temps de réponse :",
                    attendee: "Participants",
                    backHome: "Retour à l'accueil",
                    broadcast: "Diffuser",
                    cancel: "Annuler",
                    confirmDelete: "Etes-vous sûr de vouloir supprimer ?",
                    content: "Contenu",
                    createFirstSlide: "Créer votre première slide",
                    delete: "Supprimer",
                    deleteSlideshow: "Supprimer la présentation",
                    enterCode: "Entrer le code pour rejoindre : ",
                    enterResponse: "Ecrire votre réponse",
                    errorMessage: {
                        emptyCode: "Code manquant",
                        emptyTitle: "Titre manquant",
                        invalidCode: "Code invalide",
                    },
                    hideRanking: "Cacher le classement",
                    languages: {
                        english: "Anglais",
                        french: "Français",
                        other: "Autres"
                    },
                    livePolling: "Vote",
                    myPresentations: "Mes présentations",
                    newSlide: "Slide",
                    newSlideshow: "Présentation",
                    next: "Suivant",
                    no: "Non",
                    numberParticipations: "Nombre de participations : ",
                    possibleResponseNumber: "Nombre de réponse maximum par participant",
                    previous: "Précédent",
                    presentation: {
                        join: "Rejoindre la présentation",
                        manage: "Gérer une présentation",
                        present: "Présenter",
                        isPresenter: "Vous êtes présentateur ?"
                    },
                    presentationAccess: "Vous avez accès à aucune présentation",
                    presentationFinished: "La présentation est terminée",
                    question: "Question",
                    quiz: "Quiz",
                    required: {
                        options: "Minimum 2 options requises",
                        question: "Question requise",
                        response: "Réponse requise",
                        responseNumber: "Nombre de réponse maximum par participant requis",
                        responseTime: "Temps de réponse maximum requis",
                        type :"Type requis"
                    },
                    response:"Réponse",
                    responseOption: "Option de réponse",
                    responseTime: "Temps de réponse (sec)",
                    responseRequired: "Une réponse est requise",
                    responseSent: "Votre réponse a été envoyée",
                    roles: {
                        author: "Auteur",
                        owner: "Créateur",
                        presenter: "Présentateur",
                        reader: "Lecteur",
                    },
                    save: "Enregistrer",
                    selectPresentation: "Sélectionner une présentation",
                    selectResponse: 'Sélectionner la bonne réponse :',
                    send: "Envoyer",
                    shareCode: "Partager ce code avec les participants : ",
                    showRanking: "Montrer le classement",
                    showResponses: "Montrer les réponses",
                    showTestResponses: "Voir des réponses de test :",
                    slideshowAccess: "Pas de présentation disponible",
                    slideshowLabel: "Titre",
                    slideType: {
                        livePolling: "Vote",
                        presentation: "Présentation",
                        quiz: "Quiz",
                        wordCloud: "Nuage de mot",
                    },
                    startPresentation: "Commencer la présentation",
                    timeIsUp: "Le temps est écoulé !",
                    timeRemaining: "Temps restant : ",
                    title: "Titre",
                    type:"Type",
                    waitPresenter: "Attendez que la présentation commence",
                    wordCloud: "Nuage de mot",
                    yourResponse: "Votre réponse :",
                    yes: "Oui"
                }
            }
        },
        fallbackLng: "en",
        debug: true,
        ns: ["translations"],
        defaultNS: "translations"
    });

export default i18n;
